<template>
  <div>
    <div class="column is-narrow add-btn" v-if="isAdmin">
      <Dropdown trigger="click" placement="bottom-start">
        <button href="javascript:void(0)" style="cursor: pointer" class="button is-primary is-small">
          <octicon :icon="plus" />&ensp;{{ $l("global.add", "Add") }}
        </button>

        <DropdownMenu slot="list">
          <DropdownItem v-if="isRoot" @click.native="showCreatePage">
            <span>{{
      $l("components.configurationUpdate.createNew", "Create new")
    }}</span>
          </DropdownItem>

          <div class="divider" v-if="isRoot"></div>

          <DropdownItem @click.native="showUploadFileOffline">
            <span>{{
      $l(
        "components.configurationUpdate.uploadFileOffline",
        "Upload file offline"
      )
    }}</span>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>

    <data-table ref="table" :key="currentLocale" :items="versionListFunc" :per-page="20" :sort-desc="true"
      :theme="$_ui_theme_tables">
      <data-column :sortable="false" field="serial" :label="$l('components.configurationUpdate.serial', 'No')"
        width="7%" />

      <data-column field="version" :label="$l('components.configurationUpdate.name', 'Name')">
        <template #default="{ item }">
          <div class="truncate">
            {{ item.version }}
          </div>
        </template>
      </data-column>

      <data-column field="createdAt" :label="$l('components.configurationUpdate.createdAt', 'Created At')">
        <template #default="{ item }">
          {{ renderTime(item.createdAt) }}
        </template>
      </data-column>

      <data-column :sortable="false" field="user" :label="$l('components.configurationUpdate.creator', 'creator')" />

      <data-column :sortable="false" field="tagIDs" :label="$l('components.configurationUpdate.tags', 'Tags')"
        width="20%">
        <template #default="{ item }">
          {{ renderTagName(item.tagIDs) }}
        </template>

        <template #header>
          <div class="column-header">
            <span>{{ $l("components.configurationUpdate.tags", "Tags") }}</span>
            <Dropdown placement="bottom-start" trigger="custom" :visible="filter.filterTags.isFilterOpen"
              @on-clickoutside="handleCloseFilter(filter.filterTags.filterType)">
              <span href="javascript:void(0)" @click="toggleFilter('filterTags')" class="icon">
                <svg-icon type="mdi" :path="path" :class="{
      'filter-active': filter.filterTags.isSubmitFilter,
    }"></svg-icon>
              </span>
              <DropdownMenu slot="list">
                <div class="menu-list">
                  <label v-for="(i, index) in listTags" :key="index">
                    <DropdownItem>
                      <input type="checkbox" v-model="filter.filterTags.filterValues" :value="i.id" />

                      <span style="margin-left: 10px">{{ i.name }}</span>
                    </DropdownItem>
                    <div class="divider"></div>
                  </label>
                </div>
                <div class="filter-button">
                  <Button type="text" size="small" :disabled="!filter.filterTags.filterValues.length"
                    @click="submitFilter(filter.filterTags.filterType)"><span style="font-weight: bold">{{
      $l("global.submit", "Submit")
    }}</span></Button>
                  <Button type="text" size="small" color="#2096f2"
                    @click="resetFilter(filter.filterTags.filterType)"><span style="font-weight: bold">{{
      $l("global.reset", "Reset")
    }}</span></Button>
                </div>
              </DropdownMenu>
            </Dropdown>
          </div>
        </template>
      </data-column>

      <data-column :sortable="false" field="file"
        :label="$l('components.configurationUpdate.fileNumber', 'File Number')">
        <template #default="{ item }">
          <div>
            <span style="cursor: pointer" @click="switchToRepo(item)">{{
      item.file
    }}</span>
          </div>
        </template>
      </data-column>

      <data-column field="status" :label="$l('components.configurationUpdate.status', 'Status')" :sortable="false">
        <template #header>
          <div class="column-header">
            <span>{{
      $l("components.configurationUpdate.status", "status")
    }}</span>
            <Dropdown placement="bottom-start" trigger="custom" :visible="filter.filterStatus.isFilterOpen"
              @on-clickoutside="
      handleCloseFilter(filter.filterStatus.filterType)
      ">
              <span href="javascript:void(0)" @click="toggleFilter('filterStatus')" class="icon">
                <svg-icon type="mdi" :path="path" :class="{
      'filter-active': filter.filterStatus.isSubmitFilter,
    }"></svg-icon>
              </span>
              <DropdownMenu slot="list">
                <div class="menu-list">
                  <label v-for="(i, index) in listStatus" :key="index">
                    <DropdownItem>
                      <input type="checkbox" v-model="filter.filterStatus.filterValues" :value="i.value" />

                      <span style="margin-left: 10px">{{
      $l(`components.configurationUpdate.${i.name}`)
    }}</span>
                    </DropdownItem>
                    <div class="divider"></div>
                  </label>

                  <div class="filter-button">
                    <Button type="text" size="small" :disabled="!filter.filterStatus.filterValues.length"
                      @click="submitFilter(filter.filterStatus.filterType)"><span style="font-weight: bold">{{
      $l("global.submit", "Submit")
    }}</span></Button>
                    <Button type="text" size="small" color="#2096f2"
                      @click="resetFilter(filter.filterStatus.filterType)"><span style="font-weight: bold">{{
      $l("global.reset", "Reset")
    }}</span></Button>
                  </div>
                </div>
              </DropdownMenu>
            </Dropdown>
          </div>
        </template>
        <template #default="{ item }">
          <div class="status-column" :class="{
      'status-active': item.status === 1,
      'status-inactive': item.status === 2,
      'status-init': item.status === 0,
    }">
            {{
      item.status === 1
        ? $l("components.configurationUpdate.ready", "Ready")
        : item.status === 2
          ? $l("components.configurationUpdate.canceled", "Canceled")
          : $l(
            "components.configurationUpdate.initializing",
            "Initializing"
          )
    }}
          </div>
        </template>
      </data-column>

      <data-column field="type" :label="$l('components.configurationUpdate.type', 'Type')" :sortable="false">
        <template #default="{ item }">
          {{ renderTypeName(item.type) }}
        </template>

        <template #header>
          <div class="column-header">
            <span>{{ $l("components.configurationUpdate.type", "Type") }}</span>
            <Dropdown placement="bottom-start" trigger="custom" :visible="filter.filterTypes.isFilterOpen"
              @on-clickoutside="
      handleCloseFilter(filter.filterTypes.filterType)
      ">
              <span href="javascript:void(0)" @click="toggleFilter('filterTypes')" class="icon">
                <svg-icon type="mdi" :path="path" :class="{
      'filter-active': filter.filterTypes.isSubmitFilter,
    }"></svg-icon>
              </span>
              <DropdownMenu slot="list">
                <div class="menu-list">
                  <label v-for="(i, index) in listTypes" :key="index">
                    <DropdownItem>
                      <input type="checkbox" v-model="filter.filterTypes.filterValues" :value="i.value" />

                      <span style="margin-left: 10px">{{ i.name }}</span>
                    </DropdownItem>
                    <div class="divider"></div>
                  </label>
                </div>
                <div class="filter-button">
                  <Button type="text" size="small" :disabled="!filter.filterTypes.filterValues.length"
                    @click="submitFilter(filter.filterTypes.filterType)"><span style="font-weight: bold">{{
      $l("global.submit", "Submit")
    }}</span></Button>
                  <Button type="text" size="small" color="#2096f2"
                    @click="resetFilter(filter.filterTypes.filterType)"><span style="font-weight: bold">{{
      $l("global.reset", "Reset")
    }}</span></Button>
                </div>
              </DropdownMenu>
            </Dropdown>
          </div>
        </template>
      </data-column>

      <data-column :sortable="false" width="7%">
        <template v-if="isAdmin" #default="{ item }">
          <div class="actions-column-version">
            <Dropdown trigger="click" placement="bottom-start">
              <span href="javascript:void(0)" style="cursor: pointer">
                <octicon :icon="kebabHorizontal" label="kebabHorizontal" />
              </span>
              <DropdownMenu slot="list">
                <DropdownItem v-if="isRoot" @click.native="showUpdatePage(item)">
                  <span>{{
      $l("components.configurationUpdate.update", "Update")
    }}</span>
                </DropdownItem>

                <div class="divider" v-if="isRoot"></div>

                <DropdownItem @click.native="changeStatus(item)" v-if="item.status === 2 && isRoot">
                  <span style="color: #2096f2">{{
      $l("components.configurationUpdate.ready", "Ready")
    }}</span>
                </DropdownItem>
                <DropdownItem @click.native="changeStatus(item)"
                  v-if="isRoot && (item.status === 1 || item.status === 0)">
                  <span style="color: red">{{
      $l(
        "components.configurationUpdate.cancelVersion",
        "Cancel Version"
      )
    }}</span>
                </DropdownItem>
                <div class="divider" v-if="isRoot"></div>

                <DropdownItem @click.native="showForm(formModal.formInfor.type, item)">
                  <span>{{
      $l("components.configurationUpdate.viewInfor", "View Infor")
    }}</span>
                </DropdownItem>
                <div class="divider"></div>
                <DropdownItem @click.native="switchToRepo(item)">
                  <span>{{
      $l(
        "components.configurationUpdate.viewRepo",
        "View repositories"
      )
    }}</span>
                </DropdownItem>

                <div class="divider" v-if="item.status === 1 && isRoot"></div>

                <DropdownItem v-if="item.status === 1 && isRoot" @click.native="showCreateOffline(item)">
                  <span>{{
      $l(
        "components.configurationUpdate.createOfflineFile",
        "Create offline file"
      )
    }}</span>
                </DropdownItem>

                <div class="divider" v-if="item.status !== 1 && isRoot"></div>

                <DropdownItem v-if="item.status !== 1 && isRoot" @click.native="
      showForm(formModal.formDeleteVersion.type, item)
      ">
                  <span style="color: red">{{
      $l(
        "components.configurationUpdate.deleteVersion",
        "Delete version"
      )
    }}</span>
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
        </template>
      </data-column>
    </data-table>

    <modal :show.sync="formModal.formCreateOffline.isFormOpen">
      <box>
        <div class="close-icon" @click="formModal.formCreateOffline.isFormOpen = false">
          <Icon size="25" type="ios-close" />
        </div>
        <div class="repo-delete">
          <div class="columns is-multiline">
            <div class="column is-12" style="display: flex; justify-content: center">
              <label class="label">
                {{
      $l(
        "components.configurationUpdate.confirmCreateVersionOffline",
        "Confirm creation of offline version file"
      )
    }}
              </label>
            </div>
            <div class="column is-12">
              <strong>{{
        $l("components.configurationUpdate.version", "Version") + ":"
      }}</strong>
              <span style="margin-left: 20px">{{
        formModal.formCreateOffline.version
      }}</span>
            </div>
            <div class="column is-12">
              <label class="label">{{
        $l(
          "components.configurationUpdate.createVersionOfflineWarning",
          "Attention! This action may affect agent updates"
        )
      }}</label>
            </div>

            <div class="column is-12">
              <div slot="footer" class="field is-grouped is-grouped-right">
                <div class="control">
                  <Button style="margin-right: 8px" @click="formModal.formCreateOffline.isFormOpen = false">{{
      $l("global.cancel", "Cancel") }}</Button>
                </div>
                <div class="control">
                  <Button type="primary" @click="
      createVersionOffline(formModal.formCreateOffline.id)
      ">
                    {{ $l("global.submit", "Submit") }}</Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </box>
    </modal>

    <modal :show.sync="formModal.formInfor.isFormOpen">
      <box>
        <div class="close-icon" @click="formModal.formInfor.isFormOpen = false">
          <Icon size="25" type="ios-close" />
        </div>
        <div class="repo-infor">
          <div class="columns is-multiline">
            <div class="column is-12" style="display: flex; justify-content: center">
              <label class="label">{{
      $l(
        "components.configurationUpdate.versionInfor",
        "Version infor"
      )
    }}</label>
            </div>
            <div class="column is-6">
              <label class="label">{{
        $l("components.configurationUpdate.name", "Name") + ":"
      }}</label>
              <span>{{ formModal.formInfor.versionInfor.version }}</span>
            </div>
            <div class="column is-6">
              <label class="label">{{
      $l("components.configurationUpdate.creator", "Creator") + ":"
    }}</label>
              <span> {{ formModal.formInfor.versionInfor.user }} </span>
            </div>

            <div class="column is-6">
              <label class="label">{{
      $l("components.configurationUpdate.fileNumber", "File Number") +
      ":"
    }}</label>
              <span> {{ formModal.formInfor.versionInfor.file }} </span>
            </div>

            <div class="column is-6">
              <label class="label">{{
      $l("components.configurationUpdate.status", "Status") + ":"
    }}</label>
              <span :class="{
        'status-active':
          formModal.formInfor.versionInfor.status === 1,
        'status-inactive':
          formModal.formInfor.versionInfor.status === 2,
        'status-init': formModal.formInfor.versionInfor.status === 0,
      }">
                {{
      formModal.formInfor.versionInfor.status === 1
        ? $l("components.configurationUpdate.ready", "Ready")
        : formModal.formInfor.versionInfor.status === 2
          ? $l("components.configurationUpdate.canceled", "Canceled")
          : $l(
            "components.configurationUpdate.initializing",
            "Initializing"
          )
    }}
              </span>
            </div>

            <div class="column is-6">
              <label class="label">{{
        $l("components.configurationUpdate.tags", "Tags") + ":"
      }}</label>
              <span>
                {{ renderTagName(formModal.formInfor.versionInfor.tagIDs) }}
              </span>
            </div>

            <div class="column is-6">
              <label class="label">{{
      $l("components.configurationUpdate.type", "Type") + ":"
    }}</label>
              <span>
                {{ renderTypeName(formModal.formInfor.versionInfor.type) }}
              </span>
            </div>

            <div class="column is-6">
              <label class="label">{{
      $l("components.configurationUpdate.createdAt", "Created At") +
      ":"
    }}</label>
              <span>
                {{ renderTime(formModal.formInfor.versionInfor.createdAt) }}
              </span>
            </div>

            <div class="column is-6">
              <label class="label">{{
      $l("components.configurationUpdate.updatedAt", "Updated At") +
      ":"
    }}</label>
              <span>
                {{ renderTime(formModal.formInfor.versionInfor.updatedAt) }}
              </span>
            </div>
          </div>
        </div>
      </box>
    </modal>

    <modal :show.sync="formModal.formUploadOffline.isFormOpen">
      <box>
        <div class="close-icon" @click="formModal.formUploadOffline.isFormOpen = false">
          <Icon size="25" type="ios-close" />
        </div>

        <div class="column is-12" style="display: flex; justify-content: center">
          <label class="label">
            {{
      $l(
        "components.configurationUpdate.confirmCreateVersionOffline",
        "Confirm creation of offline version file"
      )
    }}
          </label>
        </div>

        <div class="p-4">
          <Row>
            <Col span="5">
            <strong>{{ $l("components.configurationUpdate.file", "File") + ":" }}
            </strong>
            </Col>

            <Col span="19">
            <div class="file" :class="{
      'file-error':
        checkErrorFile(formModal.formUploadOffline) === 0,
    }">
              <label class="file-label" style="width: 100%">
                <input class="file-input" type="file" name="resume" @change="onUploadFileOfflineChange" />
                <span class="file-cta" style="
                      width: 100%;
                      display: flex;
                      justify-content: space-between;
                      background-color: #fff;
                    ">
                  <span class="file-label">
                    {{
      formModal.formUploadOffline.file &&
        formModal.formUploadOffline.file.name
        ? formModal.formUploadOffline.file.name
        : "Choose a file ..."
    }}</span>
                  <span class="file-icon">
                    <Icon type="ios-attach" size="25" />
                  </span>
                </span>
              </label>
            </div>

            <p v-if="formModal.formUploadOffline.uploadStatus === 1"
              style="position: absolute; bottom: -35px; color: #2f80ed">
              {{
      $l(
        "components.configurationUpdate.fileUploadOfflineSuccess",
        "Download file successfully. Please wait a moment for the system to make the changes."
      )
    }}
            </p>

            <p v-if="checkErrorFile(formModal.formUploadOffline) === 0 ||
      checkErrorFile(formModal.formUploadOffline) === 1 ||
      checkErrorFile(formModal.formUploadOffline) === 2
      " style="position: absolute; bottom: -24px; color: red">
              {{
      checkErrorFile(formModal.formUploadOffline) === 0
        ? $l(
          "components.configurationUpdate.fileUploadOfflineValidFormat",
          "The format is not supported. Please, upload zip file."
        )
        : checkErrorFile(formModal.formUploadOffline) === 1
          ? $l(
            "components.configurationUpdate.fileUploadError",
            "File upload error"
          )
          : $l(
            "components.configurationUpdate.cannotBeLeftBlank",
            "Cannot be left blank"
          )
    }}
            </p>
            </Col>
          </Row>

          <div class="mt-6 field is-grouped is-grouped-right">
            <div class="control">
              <Button style="margin-right: 8px" @click="formModal.formUploadOffline.isFormOpen = false">{{
      $l("global.cancel", "Cancel") }}</Button>
            </div>
            <div class="control">
              <Button :loading="formModal.formUploadOffline.loading" type="primary"
                @click="handleClickUploadFileOffline">
                {{
      this.formModal.formUploadOffline.uploadStatus === 2
        ? $l("global.uploadAgain", "Upload again")
        : $l("global.upload", "Upload")
    }}</Button>
            </div>
          </div>
        </div>
      </box>
    </modal>

    <modal :show.sync="formModal.formDeleteVersion.isFormOpen">
      <box>
        <div class="close-icon" @click="formModal.formDeleteVersion.isFormOpen = false">
          <Icon size="25" type="ios-close" />
        </div>
        <div class="repo-delete">
          <div class="columns is-multiline">
            <div class="column is-12" style="display: flex; justify-content: center">
              <label class="label">{{
      $l(
        "components.configurationUpdate.deleteVersion",
        "Delete version"
      )
    }}</label>
            </div>
            <div class="column is-12">
              <strong class="mr-3">{{
        $l("components.configurationUpdate.version", "Version") + ":"
      }}</strong>
              <span>{{
        formModal.formDeleteVersion.version.version
          ? formModal.formDeleteVersion.version.version
          : ""
      }}</span>
            </div>
            <div class="column is-12">
              <label class="label">{{
        $l(
          "components.configurationUpdate.tagWarning",
          "Attention! This action may affect agent updates"
        )
      }}</label>
            </div>

            <div class="column is-12">
              <div slot="footer" class="field is-grouped is-grouped-right">
                <div class="control">
                  <button class="button" @click.prevent="
    formModal.formDeleteVersion.isFormOpen = false
      ">
                    {{ $l("global.close", "Close") }}
                  </button>
                </div>
                <div class="control">
                  <button class="button is-danger" @click.prevent="
      deleteVersion(formModal.formDeleteVersion.version)
      ">
                    {{ $l("global.submit", "Submit") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </box>
    </modal>
  </div>
</template>

<script>
import UpdateApi from "@/api/Update";
import { plus, kebabHorizontal, cloudUpload } from "octicons-vue";
import { Tabs, Tab, DataTable, DataColumn, Modal } from "@cyradar/ui";
import SvgIcon from "@jamescoyle/vue-icon";
import vSelect from "vue-select";

import { mapGetters } from "vuex";

import { mdiFilter } from "@mdi/js";
import Format from "date-fns/format";
import {
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Checkbox,
  Upload,
  Button,
  Form,
  FormItem,
  Input,
  Icon,
  Row,
  Col,
} from "iview";

export default {
  components: {
    Tabs,
    Tab,
    DataTable,
    DataColumn,
    Modal,
    SvgIcon,
    vSelect,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Checkbox,
    Upload,
    Button,
    Form,
    FormItem,
    Input,
    Icon,
    Row,
    Col,
  },

  computed: {
    ...mapGetters(["authenticationClaims", "isAdmin", "currentLocale"]),
  },

  data() {
    return {
      path: mdiFilter,
      cloudUpload,
      plus,
      kebabHorizontal,
      createOfflineFormModal: false,

      form: {},

      formModal: {
        formInfor: {
          isFormOpen: false,
          type: "formInfor",
          versionInfor: {
            tagIDs: [],
          },
        },
        formCreateOffline: {
          isFormOpen: false,
        },

        formUploadOffline: {
          isFormOpen: false,
          file: null,
          loading: false,
        },
        formDeleteVersion: {
          isFormOpen: false,
          type: "formDeleteVersion",
          version: {},
          loading: false,
        },
      },
      listTags: [],
      listTypes: [
        {
          value: "basic_engine",
          name: "Basic Engine",
        },
        {
          value: "installer_online",
          name: "Online Installer",
        },
        {
          value: "installer_offline",
          name: "Offline Installer",
        },
        {
          value: "db_hash",
          name: "Hash Database",
        },
        {
          value: "db_signature",
          name: "Signature Database",
        },
        {
          value: "db_resource",
          name: "Resource Database",
        },
        {
          value: "advance_engine",
          name: "Advance Engine",
        },
      ],
      listStatus: [
        {
          value: 1,
          name: "ready",
        },
        {
          value: 2,
          name: "canceled",
        },
        {
          value: 0,
          name: "initializing",
        },
      ],
      filter: {
        filterTags: {
          filterType: "tags",
          isFilterOpen: false,
          isSubmitFilter: false,
          filterValues: [],
        },
        filterStatus: {
          filterType: "status",
          isFilterOpen: false,
          isSubmitFilter: false,
          filterValues: [],
        },
        filterTypes: {
          filterType: "types",
          isFilterOpen: false,
          isSubmitFilter: false,
          filterValues: [],
        },
      },

      isRoot: null,
    };
  },

  methods: {
    // Upload file offline

    handleClickUploadFileOffline() {
      this.formModal.formUploadOffline.isClickedUpload = true;
      if (
        this.checkErrorFile(this.formModal.formUploadOffline) !== 0 &&
        this.checkErrorFile(this.formModal.formUploadOffline) !== 1 &&
        this.checkErrorFile(this.formModal.formUploadOffline) !== 2 &&
        this.formModal.formUploadOffline.file
      ) {
        this.uploadFileOffline();
      }
    },

    checkFileType(name) {
      const extension = name.split(".").pop().toLowerCase();
      switch (extension) {
        case "zip":
          return true;
        default:
          return false;
      }
    },

    checkErrorFile(item) {
      if (item.file && item.file.name && !this.checkFileType(item.file.name)) {
        return 0; // 0 là sai type
      }
      if (item.file && item.file.name && item.uploadStatus === 2) {
        return 1; // 1 là upload lỗi
      }

      if (!item.file && item.isClickedUpload) {
        return 2; // 2 là không có file
      }

      return;
    },

    showUploadFileOffline() {
      this.formModal.formUploadOffline = {
        isFormOpen: true,
        isClickedUpload: false,
        uploadStatus: 0,
        file: null,
        loading: false,
      };
    },

    onUploadFileOfflineChange() {
      const file = event.target.files[0];
      this.formModal.formUploadOffline.file = file;
    },

    uploadFileOffline() {
      this.formModal.formUploadOffline.loading = true;
      const formData = new FormData();
      formData.append("file", this.formModal.formUploadOffline.file);
      UpdateApi.uploadVersionOffline(this.$http, formData)
        .then((res) => {
          this.$store.dispatch("NOTIFY", {
            type: "success",
            text: res.message,
            duration: 10000,
          });
          this.formModal.formUploadOffline.loading = false;
          this.formModal.formUploadOffline.uploadStatus = 1;

          setTimeout(() => {
            this.formModal.formUploadOffline.isFormOpen = false;
          }, 2000);
        })

        .catch(() => {
          this.formModal.formUploadOffline.loading = false;
          this.formModal.formUploadOffline.uploadStatus = 2;
        });
    },

    // Create file offline

    showCreateOffline(item) {
      this.formModal.formCreateOffline.version = `${item.version
        }/${this.renderTypeName(item.type)}`;
      this.formModal.formCreateOffline.id = item._id;
      this.formModal.formCreateOffline.item = item;
      this.formModal.formCreateOffline.isFormOpen = true;
    },

    createVersionOffline(id) {
      UpdateApi.createVersionOffline(this.$http, id).then((res) => {
        this.formModal.formCreateOffline.isFormOpen = false;
        this.$store.dispatch("NOTIFY", {
          type: "success",
          text: "Create file offline successfully!",
          duration: 10000,
        });
        this.switchToRepo(this.formModal.formCreateOffline.item);
      });
    },

    // Show form infor

    showForm(type, item) {
      if (type === this.formModal.formInfor.type) {
        this.formModal.formInfor.isFormOpen = true;
        this.formModal.formInfor.versionInfor = item;
      } else if (type === this.formModal.formDeleteVersion.type) {
        this.formModal.formDeleteVersion.isFormOpen = true;
        this.formModal.formDeleteVersion.version = item;
      }
    },

    // Get version table

    versionListFunc(filtering, sorting, paging) {
      const params = {
        tags: this.filter.filterTags.isSubmitFilter
          ? this.filter.filterTags.filterValues.join(",")
          : "",
        status: this.filter.filterStatus.isSubmitFilter
          ? this.filter.filterStatus.filterValues.join(",")
          : "",
        types: this.filter.filterTypes.isSubmitFilter
          ? this.filter.filterTypes.filterValues.join(",")
          : "",
      };
      return UpdateApi.getVersionVueTable(
        this.$http,
        filtering,
        sorting,
        paging,
        params
      ).then((res) => {
        const dataLength = res.data.items.length;
        for (let i = 0; i < dataLength; i++) {
          res.data.items[i].serial = (paging.page - 1) * paging.perPage + i + 1;
        }
        return res.data;
      });
    },

    // Fetch

    fetchTags() {
      UpdateApi.getTagList(this.$http).then((data) => {
        let tags = data;
        this.listTags = tags.map((tag) => {
          return { name: tag.name, id: tag._id };
        });
      });
    },

    // Render table column

    renderTime(time) {
      return Format(time, "HH:mm DD/MM/YYYY");
    },

    renderTagName(vals) {
      const result = [];

      vals.map((item) => {
        const x = this.listTags.find((tag) => tag.id === item);
        if (!x) {
          vals.filter((e) => e !== item);
        } else {
          result.push(x.name);
        }
      });

      return result.join(", ");
    },

    renderTypeName(val) {
      const x = this.listTypes.find((type) => type.value === val);

      if (!x) {
        return;
      }

      return x.name;
    },

    // Filter

    toggleFilter(type) {
      event.stopPropagation();
      Object.keys(this.filter).forEach((key) => {
        if (key !== type) {
          this.filter[key].isFilterOpen = false;
        }
      });

      this.filter[type].isFilterOpen = !this.filter[type].isFilterOpen;
    },

    handleCloseFilter(filterType) {
      if (filterType === this.filter.filterStatus.filterType) {
        if (!this.filter.filterStatus.isSubmitFilter) {
          this.filter.filterStatus.filterValues = [];
        }

        this.filter.filterStatus.isFilterOpen = false;
      }

      if (filterType === this.filter.filterTypes.filterType) {
        if (!this.filter.filterTypes.isSubmitFilter) {
          this.filter.filterTypes.filterValues = [];
        }

        this.filter.filterTypes.isFilterOpen = false;
      }

      if (filterType === this.filter.filterTags.filterType) {
        if (!this.filter.filterTags.isSubmitFilter) {
          this.filter.filterTags.filterValues = [];
        }

        this.filter.filterTags.isFilterOpen = false;
      }
    },

    submitFilter(filterType) {
      if (filterType === this.filter.filterTags.filterType) {
        this.filter.filterTags.isFilterOpen = false;
        if (this.filter.filterTags.filterValues.length === 0) {
          this.filter.filterTags.isSubmitFilter = false;
        } else {
          this.filter.filterTags.isSubmitFilter = true;
          this.$refs.table.loadItems();
        }
      }

      if (filterType === this.filter.filterStatus.filterType) {
        this.filter.filterStatus.isFilterOpen = false;
        if (this.filter.filterStatus.filterValues.length === 0) {
          this.filter.filterStatus.isSubmitFilter = false;
        } else {
          this.filter.filterStatus.isSubmitFilter = true;
          this.$refs.table.loadItems();
        }
      }

      if (filterType === this.filter.filterTypes.filterType) {
        this.filter.filterTypes.isFilterOpen = false;
        if (this.filter.filterTypes.filterValues.length === 0) {
          this.filter.filterTypes.isSubmitFilter = false;
        } else {
          this.filter.filterTypes.isSubmitFilter = true;
          this.$refs.table.loadItems();
        }
      }
    },

    resetFilter(filterType) {
      if (filterType === this.filter.filterTags.filterType) {
        this.filter.filterTags.isFilterOpen = false;
        this.filter.filterTags.filterValues = [];

        if (this.filter.filterTags.isSubmitFilter) {
          this.filter.filterTags.isSubmitFilter = false;
          this.$refs.table.loadItems();
        }
      }

      if (filterType === this.filter.filterTypes.filterType) {
        this.filter.filterTypes.isFilterOpen = false;
        this.filter.filterTypes.filterValues = [];

        if (this.filter.filterTypes.isSubmitFilter) {
          this.filter.filterTypes.isSubmitFilter = false;
          this.$refs.table.loadItems();
        }
      }

      if (filterType === this.filter.filterStatus.filterType) {
        this.filter.filterStatus.isFilterOpen = false;
        this.filter.filterStatus.filterValues = [];

        if (this.filter.filterStatus.isSubmitFilter) {
          this.filter.filterStatus.isSubmitFilter = false;
          this.$refs.table.loadItems();
        }
      }
    },

    // Show create page

    showCreatePage() {
      this.$router.push({
        name: "create-version-2",
      });
    },

    // Show update page

    showUpdatePage(item) {
      this.$router.push({
        name: "update-version-2",
        params: { id: item._id },
        query: { type: item.type, version: item.version },
      });
    },

    // Update version - change status

    updateVersion() {
      UpdateApi.updateVersion(this.$http, this.form).then((res) => {
        this.$store.dispatch("NOTIFY", {
          type: "success",
          text: res.message,
          duration: 10000,
        });
        this.$refs.table.loadItems();
      });
    },

    changeStatus(item) {
      this.form = {
        _id: item._id,
        version: item.version,
        type: item.type,
        description: item.description,
        file: item.file,
        paddedVersion: item.paddedVersion,
        repositoryIDs: item.repositoryIDs,
        status:
          item.status === 1
            ? 2
            : item.status === 0
              ? 2
              : item.status === 2
                ? 1
                : 0,
        tagIDs: item.tagIDs,
      };
      this.updateVersion();
      this.form = {};
      this.$refs.table.loadItems();
    },

    async deleteVersion(item) {
      if (!item || !item._id) return;

      await UpdateApi.deleteVersion(this.$http, item._id).then((res) => {
        this.$store.dispatch("NOTIFY", {
          type: "success",
          text: res.message,
          duration: 10000,
        });
        this.$refs.table.loadItems();
      });
    },

    // Go to repo when click to view repo or file number

    switchToRepo(item) {
      this.$router.push({
        hash: "repositories",
        query: { version: item.version, type: item.type },
      });
      window.location.reload();
    },

    // Check is root

    async checkIsRoot() {
      await UpdateApi.checkIsRoot(this.$http).then((res) => {
        if (res.data && res.data.product === "root") {
          this.isRoot = true;
        }
      });
    },
  },

  mounted() {
    this.checkIsRoot();
    this.fetchTags();
  },
};
</script>

<style lang="scss" scoped>
.file-error {
  border: 1px solid red;
  border-radius: 5px;
}

.file-cta[data-v-f5238762][data-v-f5238762] {
  border: 1px solid #dbdee2;
}

.status-active {
  color: #2096f2;
}

.status-inactive {
  color: red;
}

.status-init {
  color: green;
}

.actions-column-version {
  display: flex !important;
  justify-content: center;

  .menu-button:hover {
    opacity: 0.5;
    cursor: pointer;
  }
}

.close-icon {
  position: absolute;
  top: 15px;
  right: 15px;
  cursor: pointer;

  &:hover {
    opacity: 0.5;
  }
}

/deep/ button.modal-close {
  display: none;
}

.filter {
  z-index: 2;
  position: relative;
  cursor: pointer;
  font-weight: bold;
  left: 78.5%;
  top: 67px;
  width: 10px;

  .icon {
    .filter-active {
      color: #2096f2 !important;
    }
  }
}

.file-cta {
  border-left: none;
  background-color: #fff;

  &:hover {
    background-color: #fff;
    cursor: auto;
  }}
</style>
